module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/bootstrap/dist/fonts/glyphicons-halflings-regular.eot
// module id = ../../../../bootstrap/dist/fonts/glyphicons-halflings-regular.eot
// module chunks = 2